export default __webpack_public_path__ + "static/media/scorbit.ab43f78b.png";